// extracted by mini-css-extract-plugin
module.exports = {"input":"_3Jteuk","inputRoot":"_2Qo2p7","newInput":"_15FYlk","isFocused":"Qdatfe","isDesktop":"_1guCuh"};